import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppWidget } from '../WhatsAppWidget';
import { MainHeader } from '../MainHeader';
import { Map } from '../map';
import displayImage from './display1.jpg';
import references from './references.png';
import './styles.css';

export const AboutPage = () => {
  useEffect(() => {
    document.title = "Ruesevents Designs - About";
  }, []);

  return (
    <div className="page-shell about-page">
      <MainHeader home={false} about={true} gallery={false} contact={false} />

      <section id="about-heading" className="about-hero">
        <div className="about-hero-overlay" />
        <div className="section-shell about-hero-content">
          <p className="section-kicker">About Ruesevents</p>
          <h1>Creating beautiful experiences with care, creativity and purpose.</h1>
        </div>
      </section>

      <section className="about-intro-section">
        <div className="section-shell about-intro-grid">
          <div className="about-intro-copy">
            <p className="section-kicker">Who we are</p>
            <h2>Celebrations designed around the people who matter most.</h2>
            <p>
              Ruesevents Designs (Pvt) Ltd is a privately owned Zimbabwean company established to
              serve the growing event décor and design needs of clients in Zimbabwe and neighbouring
              countries.
            </p>
            <p>
              We provide tailor-made event décor, floral design and arrangements, event management
              and hiring services. Our aim is simple: to create thoughtful, beautiful environments
              that leave unforgettable memories for our clients and their guests.
            </p>
            <Link to="/contact" className="rue-button">Start A Conversation</Link>
          </div>
          <div className="about-intro-image">
            <img src={displayImage} alt="Elegant event styling by Ruesevents Designs" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="about-purpose-section">
        <div className="section-shell purpose-grid">
          <article className="purpose-card">
            <span>01</span>
            <h2>Our Vision</h2>
            <p>To be the first choice for the event décor and floral design needs of our clients.</p>
          </article>
          <article className="purpose-card">
            <span>02</span>
            <h2>Our Mission</h2>
            <p>
              To provide services to both private and public sector clients in an efficient,
              cost-effective and mutually beneficial manner.
            </p>
          </article>
        </div>
      </section>

      <section className="clients-section">
        <div className="section-shell clients-inner">
          <p className="section-kicker">Trusted relationships</p>
          <h2 className="section-title">Some of our clients</h2>
          <p className="section-copy">
            We are proud to have supported organisations and families across a wide range of events
            and occasions.
          </p>
          <div className="clients-image-wrap">
            <img src={references} alt="A selection of Ruesevents Designs clients" loading="lazy" />
          </div>
        </div>
      </section>

      <Map />
      <WhatsAppWidget />
    </div>
  );
};
